import uuid from "uuid/v4";
import { TOUSHI_AUTH_CLIENT_ID, TOUSHI_AUTH_URL } from "../constants";
import { CONFIGS } from "@/constants";

export function toushiAuth() {
  const state = uuid();
  const redirect = CONFIGS.WEB_HOST + "/hfox/toushi/callback";
  const url =
    TOUSHI_AUTH_URL +
    `?client_id=${TOUSHI_AUTH_CLIENT_ID}&response_type=code&state=${state}&redirect_uri=${redirect}`;

  localStorage.setItem("hfox_toushi_auth_state", state);
  localStorage.setItem("hfox_store_path", window.location.href);
  window.location.href = url;
}
